module.exports = __webpack_public_path__ + "img/icon_963.3efefa8c.png";